
export type GetOrderInfo401 = {
  code?: string;
  error: string;
  success: boolean;
  timestamp?: string;
};
